import dictionary from "../langs.json";

export enum TaskStatusEnum {
  InDevelopment = 0,
  Demo,
  InModule,
  Reserved,
}

export let isTaskStatus = (variable: unknown): variable is TaskStatusEnum => {
  return (
    variable !== null &&
    variable !== undefined &&
    typeof variable === "number" &&
    variable in TaskStatusEnum
  );
};

export function getTaskStatusString(status: TaskStatusEnum) {
  return dictionary.ru.translation[
    ("taskStatus" + status) as keyof typeof dictionary.ru.translation
  ];
}
